import React, { useState, useEffect } from 'react';
import Sidebar from './components/Sidebar'
import ReactQuill from "react-quill"
import 'react-quill/dist/quill.snow.css'
import axios from 'axios'

const About = () => {
  // const [image, setImage] = useState(null);
  const [, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState('')
  const [contentId, setContentId] = useState(null);
  const [contents, setContents] = useState([])
  const [formData, setFormData] = useState({
    publicationName: '',
    publicationNames: '',
    publicationLink: '',
  });
  const [honorsData, setHonorsData] = useState({
    HonorsName: '',
    HonorsNames: '',
    HonorsLink: '',
  });
  const [publications, setPublications] = useState([])
  const [honors, setHonors] = useState([])
  const emptyExhibition = { year: '', exhibitionName: '', exhibitionLink: '' };
  const [soloData, setSoloData] = useState(emptyExhibition)
  const [groupData, setGroupData] = useState(emptyExhibition)
  const [soloExhibitions, setSoloExhibitions] = useState([])
  const [groupExhibitions, setGroupExhibitions] = useState([])
  const [name, setName] = useState('')
  const [link, setLink] = useState('')
  const [files, setFiles] = useState('')
  const [press, setPress] = useState([]);

  // const URL = import.meta.env.VITE_BASE_URL;


  
  // ABOUT TEXT UPLOAD

// Upload New Content
const handleAboutTextUpload = async () => {
  if (!content.trim()) {
    alert("Please enter some content before uploading.");
    return;
  }

  setLoading(true);

  try {
    await axios.post(`${process.env.REACT_APP_API_URL}/abouttext`, { content });

    alert("Content uploaded successfully!");
    setContent(""); // Clear editor
    fetchUploadedContent(); // Refresh content
  } catch (error) {
    alert("Failed to upload content.");
  } finally {
    setLoading(false);
  }
};

// Fetch Content
const fetchUploadedContent = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/abouttext`);
    if (response.ok) {
      const data = await response.json();
      if (data.about) {
        setContents([data.about]);
        setContentId(data.about._id); // Store the document ID
      }
    }
  } catch (error) {
    console.error("Error fetching content:", error);
  }
};

// Edit Existing Content
const handleEdit = (con) => {
  setContent(con.content);
  setContentId(con._id);
};

// Update Content
const updateAboutText = async () => {
  if (!contentId) {
    alert("No content selected for updating.");
    return;
  }

  try {
    await axios.put(`${process.env.REACT_APP_API_URL}/abouttext/${contentId}`, { content });

    alert("Content updated successfully!");
    fetchUploadedContent(); // Refresh content
  } catch (error) {
    alert("Failed to update content.");
  }
};

useEffect(() => {
  fetchUploadedContent();
}, []);





  

  const handleUpload = async () => {
    try {
      const data = new FormData();
      data.set('name', name);
      data.set('link', link);
      data.set('file', files[0]);

      // const response = await fetch(`${process.env.REACT_APP_API_URL}/client`, {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/client`, {
        method: 'POST',
        body: data,
      });

      if (response.ok) {
        alert('press uploaded successfully');
        setName('');
        setLink('');
        setImages([]);

        // Refresh the page after successful submission
        window.location.reload();
      } else {
        console.error('Error uploading image:', response.statusText);
      }
    } catch (error) {
      console.error('Error uploading image:', error);
    }
  };

  const fetchUploadedPress = async () => {
    try {
      // const response = await fetch(`${process.env.REACT_APP_API_URL}/client`);
      const response = await fetch(`${process.env.REACT_APP_API_URL}/client`);

      if (response.ok) {
        const data = await response.json();
        console.log("press", data.press)
        setPress(data.press || []); // Update state with the fetched items
      } else {
        console.error('Error fetching uploaded press:', response.statusText);
      }
    } catch (error) {
      console.error('Error fetching uploaded press:', error);
    }
  };

  useEffect(() => {
    fetchUploadedPress();
  }, []);

  const handleDeletePress = async (clientId) => {
    console.log('Deleting client with ID:', clientId);
    try {
      // const response = await fetch(`${process.env.REACT_APP_API_URL}/client/${clientId}`, { 
      const response = await fetch(`${process.env.REACT_APP_API_URL}/client/${clientId}`, { 
        method: 'DELETE' 
      });

      if (response.ok) {
        setPress((prevPress) => prevPress.filter((item) => item._id !== clientId));
        alert('Press deleted successfully');
      } else {
        const errorData  = await response.json();
        console.error('Error deleting Image:', errorData);
      }
    } catch (error) {
      console.error('Error deleting Image:', error);
    }
  };



  // PUBLICATION FUNCTION
  const handlePublicationUpload = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/publications`, {
      // const response = await fetch(`${process.env.REACT_APP_API_URL}/publications`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        alert('New publication successfully created')
        setFormData({
          publicationName: '',
          publicationNames: '',
          publicationLink: '',
        });

        // Refresh the page after successful submission
        window.location.reload();
      } else {
        console.error('Error creating portfolio title:', response.statusText);
      }
    } catch (error) {
      console.error('Error creating portfolio title:', error);
    } finally {
      setLoading(false); // End loading after submission completes
    }
  };

  useEffect(() => {
    // Fetch data from the backend
    fetchPublications();
  }, []);

  const fetchPublications = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/publications`);
        // const response = await fetch(`${process.env.REACT_APP_API_URL}/publications`);
        if (response.ok) {
          const data = await response.json();
          setPublications(data);
        } else {
          console.error('Error fetching data');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
  };

  const handleDeletePublication = async (publicationId) => {
    console.log('Deleting publication with ID:', publicationId);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/publications/${publicationId}`, { 
      // const response = await fetch(`${process.env.REACT_APP_API_URL}/publications/${publicationId}`, { 
        method: 'DELETE', 
      });

      if (response.ok) {
        // Remove the deleted publication from the state
        setPublications((prevPublications) => 
          prevPublications.filter((publication) => publication._id !== publicationId)
        );
        alert('Publication deleted successfully');
      } else {
        const errorData = await response.json();
        console.error('Error deleting publication:', errorData);
      }
    } catch (error) {
      console.error('Error deleting publication:', error);
    }
  };

  // Publications are ordered manually (newest first); swap a row with its neighbour.
  const handleMovePublication = async (publicationId, direction) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/publications/${publicationId}/move`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ direction }),
      });

      if (response.ok) {
        fetchPublications();
      } else {
        const errorData = await response.json();
        console.error('Error moving publication:', errorData);
      }
    } catch (error) {
      console.error('Error moving publication:', error);
    }
  };

  const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    };




  // EXHIBITIONS FUNCTION (solo & group)
  const fetchExhibitions = async (category, setter) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/about-exhibitions?category=${category}`);
      if (response.ok) {
        setter(await response.json());
      } else {
        console.error('Error fetching exhibitions');
      }
    } catch (error) {
      console.error('Error fetching exhibitions:', error);
    }
  };

  useEffect(() => {
    fetchExhibitions('solo', setSoloExhibitions);
    fetchExhibitions('group', setGroupExhibitions);
  }, []);

  const handleExhibitionUpload = async (category, data, reset) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/about-exhibitions`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...data, category }),
      });

      if (response.ok) {
        alert('New exhibition successfully created');
        reset(emptyExhibition);
        window.location.reload();
      } else {
        console.error('Error creating exhibition:', response.statusText);
      }
    } catch (error) {
      console.error('Error creating exhibition:', error);
    }
  };

  const handleDeleteExhibition = async (id, category) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/about-exhibitions/${id}`, {
        method: 'DELETE',
      });

      if (response.ok) {
        const setter = category === 'solo' ? setSoloExhibitions : setGroupExhibitions;
        setter((prev) => prev.filter((ex) => ex._id !== id));
        alert('Exhibition deleted successfully');
      } else {
        const errorData = await response.json();
        console.error('Error deleting exhibition:', errorData);
      }
    } catch (error) {
      console.error('Error deleting exhibition:', error);
    }
  };

  // Exhibitions are ordered manually (newest first); swap a row with its neighbour.
  const handleMoveExhibition = async (id, category, direction) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/about-exhibitions/${id}/move`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ direction }),
      });

      if (response.ok) {
        fetchExhibitions(category, category === 'solo' ? setSoloExhibitions : setGroupExhibitions);
      } else {
        const errorData = await response.json();
        console.error('Error moving exhibition:', errorData);
      }
    } catch (error) {
      console.error('Error moving exhibition:', error);
    }
  };

  // Shared dark-theme admin UI styles (site palette: #252525 / #b7a78b)
  const ui = {
    card: "bg-[#1d1d1d] rounded-xl border border-[#484540] p-6 md:p-8 mb-8 shadow-lg",
    title: "text-xl font-semibold mb-1 capitalize text-[#e7ddd3] tracking-wide",
    subtitle: "text-sm text-[#8a8175] mb-6",
    label: "block text-xs font-medium text-[#8a8175] uppercase tracking-wide mb-1.5",
    input:
      "w-full bg-[#252525] border border-[#484540] rounded-lg px-4 py-2.5 mb-4 text-sm text-[#e4e4e3] placeholder-[#6f675c] focus:outline-none focus:ring-2 focus:ring-[#b7a78b] focus:border-transparent transition",
    primaryBtn:
      "inline-flex items-center justify-center bg-[#b7a78b] hover:bg-[#d0c3a6] text-[#252525] text-sm font-semibold px-8 py-3 rounded-lg uppercase tracking-wide transition-colors disabled:opacity-50",
    deleteBtn:
      "bg-red-600/90 hover:bg-red-600 text-white text-xs font-semibold uppercase px-4 py-2 rounded-md transition-colors",
    editBtn:
      "bg-[#252525] border border-[#484540] hover:border-[#b7a78b] text-[#e4e4e3] text-xs font-semibold uppercase px-4 py-2 rounded-md transition-colors",
    orderBtn:
      "bg-[#252525] border border-[#484540] hover:border-[#b7a78b] text-[#e4e4e3] text-sm leading-none px-3 py-2 rounded-md transition-colors disabled:opacity-30 disabled:hover:border-[#484540] disabled:cursor-not-allowed",
    tableWrap: "overflow-x-auto rounded-lg border border-[#484540] mt-6",
    table: "min-w-full divide-y divide-[#484540]",
    th: "px-6 py-3 text-left text-xs font-semibold text-[#8a8175] uppercase tracking-wider bg-[#252525]",
    td: "px-6 py-4 whitespace-nowrap text-sm text-[#cdc2ad]",
    tr: "hover:bg-[#252525] transition-colors",
    emptyRow: "px-6 py-8 text-center text-sm text-[#8a8175]",
  };

  // Reusable admin block for a solo/group exhibition list
  const renderExhibitionSection = (title, category, data, setData, list) => (
    <div className={ui.card}>
      <h2 className={ui.title}>{title}</h2>
      <p className={ui.subtitle}>Add a {category} exhibition to the About page.</p>

      <div className="grid gap-x-4 sm:grid-cols-2 max-w-3xl">
        <div>
          <label className={ui.label}>Year</label>
          <input
            className={ui.input}
            type="text"
            placeholder="e.g. 2024"
            value={data.year}
            onChange={(e) => setData((p) => ({ ...p, year: e.target.value }))}
          />
        </div>
        <div>
          <label className={ui.label}>Link (optional)</label>
          <input
            className={ui.input}
            type="text"
            placeholder="https://…"
            value={data.exhibitionLink}
            onChange={(e) => setData((p) => ({ ...p, exhibitionLink: e.target.value }))}
          />
        </div>
        <div className="sm:col-span-2">
          <label className={ui.label}>Exhibition</label>
          <input
            className={ui.input}
            type="text"
            placeholder="Title, venue, location"
            value={data.exhibitionName}
            onChange={(e) => setData((p) => ({ ...p, exhibitionName: e.target.value }))}
          />
        </div>
      </div>

      <button
        className={ui.primaryBtn}
        disabled={loading}
        onClick={() => handleExhibitionUpload(category, data, setData)}
      >
        {loading ? 'Uploading…' : `Add ${title.replace(' Exhibitions', '')}`}
      </button>

      <div className={ui.tableWrap}>
        <table className={ui.table}>
          <thead>
            <tr>
              <th className={ui.th}>s/n</th>
              <th className={ui.th}>year</th>
              <th className={ui.th}>exhibition</th>
              <th className={ui.th}>link</th>
              <th className={ui.th}>order</th>
              <th className={ui.th}>delete</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#484540]">
            {list.length > 0 ? list.map((ex, index) => (
              <tr className={ui.tr} key={ex._id}>
                <td className={ui.td}>{index + 1}</td>
                <td className={ui.td}>{ex.year}</td>
                <td className={ui.td}>{ex.exhibitionName}</td>
                <td className={`${ui.td} max-w-[220px] truncate`}>{ex.exhibitionLink}</td>
                <td className={ui.td}>
                  <div className="flex items-center gap-2">
                    <button
                      className={ui.orderBtn}
                      title="Move up"
                      disabled={index === 0}
                      onClick={() => handleMoveExhibition(ex._id, category, 'up')}
                    >
                      ↑
                    </button>
                    <button
                      className={ui.orderBtn}
                      title="Move down"
                      disabled={index === list.length - 1}
                      onClick={() => handleMoveExhibition(ex._id, category, 'down')}
                    >
                      ↓
                    </button>
                  </div>
                </td>
                <td className={ui.td}>
                  <button
                    className={ui.deleteBtn}
                    onClick={() => handleDeleteExhibition(ex._id, category)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            )) : (
              <tr>
                <td className={ui.emptyRow} colSpan={6}>No {category} exhibitions yet.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );





  // HONORS FUNCTION

  const handleHonorsUpload = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/honors`, {
      // const response = await fetch(`${process.env.REACT_APP_API_URL}/honors`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(honorsData),
      });

      if (response.ok) {
        alert('New honors successfully created')
        setHonorsData({
          honorsName: '',
          honorsNames: '',
          honorsLink: '',
        });

        // Refresh the page after successful submission
        window.location.reload();
      } else {
        console.error('Error creating honors title:', response.statusText);
      }
    } catch (error) {
      console.error('Error creating honors title:', error);
    } finally {
      setLoading(false); // End loading after submission completes
    }
  };

  useEffect(() => {
    // Fetch data from the backend
    fetchHonors();
  }, []);

  const fetchHonors = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/honors`); // Replace with your backend endpoint
        // const response = await fetch(`${process.env.REACT_APP_API_URL}/honors`);
        if (response.ok) {
          const data = await response.json();
          setHonors(data);
        } else {
          console.error('Error fetching data');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
  };

  const handleDeleteHonors = async (honorsId) => {
    console.log('Deleting honors with ID:', honorsId);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/honors/${honorsId}`, { 
      // const response = await fetch(`${process.env.REACT_APP_API_URL}/honors/${honorsId}`, { 
        method: 'DELETE', 
      });

      if (response.ok) {
        // Remove the deleted honor from the state
        setHonors((prevHonors) => 
          prevHonors.filter((honor) => honor._id !== honorsId)
        );
        alert('Honor deleted successfully');
      } else {
        const errorData = await response.json();
        console.error('Error deleting honor:', errorData);
      }
    } catch (error) {
      console.error('Error deleting honor:', error);
    }
  };  

  const handleHonorsChange = (e) => {
      const { name, value } = e.target;
      setHonorsData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    };

  






  return (
    <>
      <div className="flex">
        <Sidebar />

        <div className="flex-1 bg-[#252525] min-h-screen mb-20 px-4 md:px-8 pb-10">
          <div>
            <div className="sticky top-0 z-10 flex items-center justify-between border-b border-[#484540] bg-[#1d1d1d] rounded-b-lg px-6 py-4 mb-8">
              <p className="text-sm font-medium text-[#8a8175]">Admin Dashboard</p><span className="text-sm font-semibold text-[#e7ddd3]">Welcome, Admin</span>
            </div>



          {/* ABOUT TEXT */}
          <div className={ui.card}>
            <h2 className={ui.title}>About Text</h2>
            <p className={ui.subtitle}>Write the biography shown on the public About page.</p>

            <div className="bg-white rounded-lg overflow-hidden mb-4">
              <ReactQuill className="h-[60vh]" value={content} onChange={setContent} />
            </div>

            <button
              className={ui.primaryBtn}
              disabled={loading}
              onClick={contentId ? updateAboutText : handleAboutTextUpload}
            >
              {loading ? 'Uploading…' : contentId ? 'Update Content' : 'Upload Content'}
            </button>

            <div className="mt-10">
              <h3 className="text-sm font-semibold text-[#8a8175] uppercase tracking-wide mb-2">Uploaded Content</h3>
              <div className={ui.tableWrap}>
                <table className={ui.table}>
                  <thead>
                    <tr>
                      <th className={ui.th}>S/N</th>
                      <th className={ui.th}>About Write Up</th>
                      <th className={ui.th}>Actions</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-[#484540]">
                    {contents.map((con, index) => (
                      <tr key={con._id} className={ui.tr}>
                        <td className={ui.td}>{index + 1}</td>
                        <td className="px-6 py-4 text-sm text-[#cdc2ad] whitespace-normal max-w-xl truncate">{con.content}</td>
                        <td className={ui.td}>
                          <button className={ui.editBtn} onClick={() => handleEdit(con)}>
                            Edit
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>








            <div className={ui.card}>
              <h2 className={ui.title}>Press</h2>
              <p className={ui.subtitle}>Upload press features shown in the “Recent Press” column.</p>

              <div className="max-w-3xl">
                <label className={ui.label}>Cover image</label>
                <input
                  type="file"
                  onChange={(ev) => setFiles(ev.target.files)}
                  className="block w-full text-sm text-[#cdc2ad] mb-4 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:bg-[#b7a78b] file:text-[#252525] file:font-semibold file:cursor-pointer cursor-pointer"
                />
                <label className={ui.label}>Press title</label>
                <input
                  className={ui.input}
                  type="text"
                  name="name"
                  placeholder="Press title"
                  value={name}
                  onChange={(ev) => setName(ev.target.value)}
                />
                <label className={ui.label}>Link</label>
                <input
                  className={ui.input}
                  type="text"
                  name="link"
                  placeholder="https://…"
                  value={link}
                  onChange={(ev) => setLink(ev.target.value)}
                />
              </div>

              <button
                type="button"
                className={ui.primaryBtn}
                disabled={loading}
                onClick={async () => {
                  setLoading(true);
                  await handleUpload();
                  setLoading(false);
                }}
              >
                {loading ? 'Uploading Press…' : 'Upload Press'}
              </button>

              <div className={ui.tableWrap}>
                <table className={ui.table}>
                  <thead>
                    <tr>
                      <th className={ui.th}>s/n</th>
                      <th className={ui.th}>image</th>
                      <th className={ui.th}>press</th>
                      <th className={ui.th}>link</th>
                      <th className={ui.th}>delete</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-[#484540]">
                    {press && press.length > 0 ? press.map((pre, index) => (
                      <tr className={ui.tr} key={pre._id}>
                        <td className={ui.td}>{index + 1}</td>
                        <td className="px-6 py-4">
                          <img src={pre.cover} alt={`Item ${index + 1}`} className="h-12 w-12 object-cover rounded-md border border-[#484540]" />
                        </td>
                        <td className={ui.td}>{pre.name}</td>
                        <td className={`${ui.td} max-w-[220px] truncate`}>{pre.link}</td>
                        <td className={ui.td}>
                          <button
                            className={ui.deleteBtn}
                            onClick={() => handleDeletePress(pre._id)}>
                            Delete
                          </button>
                        </td>
                      </tr>
                    )) : (
                      <tr>
                        <td className={ui.emptyRow} colSpan={5}>No press uploaded yet.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>



          {/*// PUBLICATIONS*/}
          <div className={ui.card}>
            <h2 className={ui.title}>Publications</h2>
            <p className={ui.subtitle}>Add a publication to the About page.</p>

            <div className="max-w-3xl">
              <label className={ui.label}>Publication name</label>
              <input
                className={ui.input}
                type="text"
                name="publicationName"
                placeholder="Publication name"
                value={formData.publicationName}
                onChange={handleInputChange}
              />
              <label className={ui.label}>Publication (optional)</label>
              <input
                className={ui.input}
                type="text"
                name="publicationNames"
                placeholder="Publication (title / detail)"
                value={formData.publicationNames}
                onChange={handleInputChange}
              />
              <label className={ui.label}>Link (optional)</label>
              <input
                className={ui.input}
                type="text"
                name="publicationLink"
                placeholder="https://…"
                value={formData.publicationLink}
                onChange={handleInputChange}
              />
            </div>

            <button
              className={ui.primaryBtn}
              disabled={loading}
              onClick={handlePublicationUpload}>
              {loading ? 'Uploading…' : 'Add Publication'}
            </button>

            <div className={ui.tableWrap}>
              <table className={ui.table}>
                <thead>
                  <tr>
                    <th className={ui.th}>s/n</th>
                    <th className={ui.th}>publication</th>
                    <th className={ui.th}>detail</th>
                    <th className={ui.th}>link</th>
                    <th className={ui.th}>order</th>
                    <th className={ui.th}>delete</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-[#484540]">
                  {publications.length > 0 ? publications.map((pub, index) => (
                    <tr className={ui.tr} key={pub._id}>
                      <td className={ui.td}>{index + 1}</td>
                      <td className={ui.td}>{pub.publicationName}</td>
                      <td className={ui.td}>{pub.publicationNames}</td>
                      <td className={`${ui.td} max-w-[220px] truncate`}>{pub.publicationLink}</td>
                      <td className={ui.td}>
                        <div className="flex items-center gap-2">
                          <button
                            className={ui.orderBtn}
                            title="Move up"
                            disabled={index === 0}
                            onClick={() => handleMovePublication(pub._id, 'up')}
                          >
                            ↑
                          </button>
                          <button
                            className={ui.orderBtn}
                            title="Move down"
                            disabled={index === publications.length - 1}
                            onClick={() => handleMovePublication(pub._id, 'down')}
                          >
                            ↓
                          </button>
                        </div>
                      </td>
                      <td className={ui.td}>
                        <button
                          className={ui.deleteBtn}
                          onClick={() => handleDeletePublication(pub._id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td className={ui.emptyRow} colSpan={6}>No publications yet.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>




          {/* SOLO & GROUP EXHIBITIONS */}
          {renderExhibitionSection('Solo Exhibitions', 'solo', soloData, setSoloData, soloExhibitions)}
          {renderExhibitionSection('Group Exhibitions', 'group', groupData, setGroupData, groupExhibitions)}




          {/* HONORS */}
          <div className={ui.card}>
            <h2 className={ui.title}>Honors</h2>
            <p className={ui.subtitle}>Add an honor or award to the About page.</p>

            <div className="max-w-3xl">
              <label className={ui.label}>Honor name</label>
              <input
                className={ui.input}
                type="text"
                name="honorsName"
                placeholder="Honor name"
                value={honorsData.honorsName}
                onChange={handleHonorsChange}
              />
              <label className={ui.label}>Honor</label>
              <input
                className={ui.input}
                type="text"
                name="honorsNames"
                placeholder="Honor (title / detail)"
                value={honorsData.honorsNames}
                onChange={handleHonorsChange}
              />
              <label className={ui.label}>Link</label>
              <input
                className={ui.input}
                type="text"
                name="honorsLink"
                placeholder="https://…"
                value={honorsData.honorsLink}
                onChange={handleHonorsChange}
              />
            </div>

            <button
              className={ui.primaryBtn}
              disabled={loading}
              onClick={handleHonorsUpload}>
              {loading ? 'Uploading…' : 'Add Honor'}
            </button>

            <div className={ui.tableWrap}>
              <table className={ui.table}>
                <thead>
                  <tr>
                    <th className={ui.th}>s/n</th>
                    <th className={ui.th}>honor</th>
                    <th className={ui.th}>detail</th>
                    <th className={ui.th}>link</th>
                    <th className={ui.th}>delete</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-[#484540]">
                  {honors.length > 0 ? honors.map((hon, index) => (
                    <tr className={ui.tr} key={hon._id}>
                      <td className={ui.td}>{index + 1}</td>
                      <td className={ui.td}>{hon.honorsName}</td>
                      <td className={ui.td}>{hon.honorsNames}</td>
                      <td className={`${ui.td} max-w-[220px] truncate`}>{hon.honorsLink}</td>
                      <td className={ui.td}>
                        <button
                          className={ui.deleteBtn}
                          onClick={() => handleDeleteHonors(hon._id)}>
                          Delete
                        </button>
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td className={ui.emptyRow} colSpan={5}>No honors yet.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>







        </div>

      </div>
    </>
  );
};

export default About;